<template>
     <div class="infoPanelThree" :class="{infoPanelThree3:type == 'max'}">
        <div class="panelTitle">{{title}}</div>
        <div class="panelCount" :style="{'color':Color}">{{count}}</div>
      </div>
</template>
<script>


export default {
    name: 'CardHegu3',
    props:{
        title: {
            type: String,
            default: '',
        },
        Color: {
            type: String,
            default: '#fff',
        },
        count:{
            type:Number|String,
            default:0,
        },
        type:{
            type:String,
            default:'min',
        },
    },
    data(){
        return{
        }
    },
    watch:{
    },
    methods:{
       
    },
    mounted(){
    
    }
}
</script>
<style lang="stylus" scoped>
.infoPanelThree{
    width: 100%;
    height: 100%;
    border-radius:0.5rem;
    background-color:rgba(13, 81, 122, 0.4);
    display: flex;
    flex-direction: column;
    .panelTitle{
        flex: 0 0 auto;
        width: 100%;
        height: 2.5rem;
        display:flex;
        align-items:center;
        justify-content:center;
        font-family:'PingFangSC-Bold';
        font size 1.4rem;
        letter-spacing:0.2rem;
        color: #7DFFFF;
        border-bottom: 0.1rem solid #0D517A;
    }
    .panelCount{
        width: 100%;
        height: 100%;
        display:flex;
        align-items:center;
        justify-content:center;
        font-size:2.4rem;
        font-family:'PingFangSC-Bold';
    }

}
.infoPanelThree3{
    .panelTitle{
        height: 5rem;
        font-size:1.8rem;
        background: rgba(13, 81, 122, 0.4);
    }
    .panelCount{
         font-size:3.6rem;
    }
}
</style>